module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('p', {
    staticClass: "Head1"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "chapterTitle1"
  }, [_vm._v("Alarums and Incursions")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("here is only one line that tells us anything about the Roman invasion of the Isle of Wight. The biographer Suetonius wrote that Vespasian, sweeping along the south coast with the II Legio Augusta, took Vectis (the Island), defeated two warlike tribes ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("validissime gentes")]), _vm._v(") and captured over twenty fortresses ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oppida")]), _vm._v("). The tribes were probably the Durotriges of what is today Dorset and the Dobunni further east in what would become Hampshire and Sussex. The fortresses are more likely to be hill-top forts on the mainland, but there is at least the possibility of one standing on a hill in the centre of the Island which is now the site of Carisbrooke Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What was Vespasian doing in the Island in the first place? He was part of the Claudian invasion of AD 43, but that is in itself a misnomer. The Emperor Claudius was hardly the stuff of which soldiers are made and if he was not exactly the limping, stammering idiot of Robert Graves’ famous novel, he was certainly no general. He turned up, as Emperors often did, at the very end of the campaign, to claim laurels and wave to crowds - and came nowhere near Vectis.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The hard work was done by Aulus Plautius, who began a systematic attack on the disunited tribes of Britain, using the formidable tactics of the Roman legions. Worthy opponents like Caratacus were driven back into the forested mountains of Wales and Vespasian, with just a single legion, was taking a huge gamble in his march westward along the south coast.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11de83a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_ch1.vue
// module id = 72
// module chunks = 0